
import { Routes } from '@angular/router';
import { AppShellComponent } from './core/layout/app-shell/app-shell.component';
import { authorizationGuard } from './core/auth/guards/authorization.guard';
import { authenticationGuard } from './core/auth/guards/authentication.guard';
import { RouteAuthPolicy } from './core/auth/models';

import { roleRedirectGuard } from './core/auth/guards/role-redirect.guard';
import { RootRedirectComponent } from './core/layout/root-redirect.component';
import { environment } from '../environments/environment';

const shipmentsAccessPolicy: RouteAuthPolicy = {
  anyPermissions: ['landing_page']
};

const statementBillingAccessPolicy: RouteAuthPolicy = {
  anyPermissions: ['statement_billing']
};

const userManagementAccessPolicy: RouteAuthPolicy = {
  anyPermissions: ['is_admin']
};

const dashboardAccessPolicy: RouteAuthPolicy = {
  anyPermissions: ['is_admin']
};

const reportsAccessPolicy: RouteAuthPolicy = {
  anyPermissions: ['reporting']
};

const trackShipmentAccessPolicy: RouteAuthPolicy = {
  anyPermissions: ['landing_page']
};
const localizedShipmentsPath = $localize`:@@shipmentsDeepLinkPath:Shipments`;
const alternateShipmentsPath = localizedShipmentsPath === 'Shipments' ? 'expedition' : 'Shipments';
const localizedTrackShipmentsPath = $localize`:@@trackShipmentsDeepLinkPath:track-shipment`;
const alternateTrackShipmentsPath = localizedTrackShipmentsPath === 'track-shipment' ? 'suivi-expedition' : 'track-shipment';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: RootRedirectComponent,
    canActivate: [roleRedirectGuard]
  },
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authenticationGuard],
    canActivateChild: [authenticationGuard],
    children: [
      {
        path: 'reports',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: reportsAccessPolicy
        },
        loadChildren: () => import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES)
      },
      {
        path: 'rapports',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: reportsAccessPolicy
        },
        loadChildren: () => import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES)
      },
      {
        path: 'shipments/:shipmentNumber',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: shipmentsAccessPolicy
        },
        loadChildren: () => import('./features/shipments/shipments.routes').then((m) => m.SHIPMENTS_ROUTES)
      },
      {
        path: 'expeditions/:shipmentNumber',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: shipmentsAccessPolicy
        },
        loadChildren: () => import('./features/shipments/shipments.routes').then((m) => m.SHIPMENTS_ROUTES)
      },
      {
        path: 'shipments',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: shipmentsAccessPolicy
        },
        loadChildren: () => import('./features/shipments/shipments.routes').then((m) => m.SHIPMENTS_ROUTES)
      },
      {
        path: 'expeditions',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: shipmentsAccessPolicy
        },
        loadChildren: () => import('./features/shipments/shipments.routes').then((m) => m.SHIPMENTS_ROUTES)
      },
      {
        path: 'track-shipment/:shipmentNumber',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: trackShipmentAccessPolicy
        },
        loadChildren: () => import('./features/track-shipment/track-shipment.routes').then((m) => m.TRACK_SHIPMENT_ROUTES)
      },
      {
        path: 'suivi-expedition/:shipmentNumber',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: trackShipmentAccessPolicy
        },
        loadChildren: () => import('./features/track-shipment/track-shipment.routes').then((m) => m.TRACK_SHIPMENT_ROUTES)
      },
      {
        path: localizedTrackShipmentsPath,
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: trackShipmentAccessPolicy
        },
        loadChildren: () => import('./features/track-shipment/track-shipment.routes').then((m) => m.TRACK_SHIPMENT_ROUTES)
      },
      {
        path: alternateTrackShipmentsPath,
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: trackShipmentAccessPolicy
        },
        loadChildren: () => import('./features/track-shipment/track-shipment.routes').then((m) => m.TRACK_SHIPMENT_ROUTES)
      },
      {
        path: localizedShipmentsPath,
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: shipmentsAccessPolicy
        },
        loadChildren: () => import('./features/shipments/shipments.routes').then((m) => m.SHIPMENTS_ROUTES)
      },
      {
        path: alternateShipmentsPath,
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: shipmentsAccessPolicy
        },
        loadChildren: () => import('./features/shipments/shipments.routes').then((m) => m.SHIPMENTS_ROUTES)
      },
      {
        path: 'statement-billing',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: statementBillingAccessPolicy
        },
        loadChildren: () => import('./features/statement-billing/statement-billing.routes').then((m) => m.STATEMENT_BILLING_ROUTES)
      },
      {
        path: 'invoicing',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: statementBillingAccessPolicy
        },
        loadChildren: () => import('./features/statement-billing/statement-billing.routes').then((m) => m.STATEMENT_BILLING_ROUTES)
      },
      {
        path: 'facturation',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: statementBillingAccessPolicy
        },
        loadChildren: () => import('./features/statement-billing/statement-billing.routes').then((m) => m.STATEMENT_BILLING_ROUTES)
      },
      {
        path: 'user-management',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: userManagementAccessPolicy
        },
        loadChildren: () => import('./features/user-management/user-management.routes').then((m) => m.USER_MANAGEMENT_ROUTES)
      },
      {
        path: 'dashboard',
        canMatch: environment.name === 'local' ? [] : [authorizationGuard],
        data: {
          auth: dashboardAccessPolicy
        },
        loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES)
      },
      {
        path: 'unauthorized',
        loadChildren: () => import('./features/unauthorized/unauthorized.routes').then((m) => m.UNAUTHORIZED_ROUTES)
      }
    ]
  },
  {
    path: '**',
    component: RootRedirectComponent,
    canActivate: [roleRedirectGuard]
  }
];
